import { Tooltip } from 'antd';

import defaultImage from 'assets/images/default-image.png';
import onlineIcon from 'assets/images/online.svg';
import { dateFormat } from 'formatters/date';
import { sendEventToGA } from 'helpers/tagManager';
import { Marketplace } from 'interfaces/marketplace';
import { BLINKET_EVENT_URL } from 'settings';

import styles from './styles.module.css';

type ItemCardProps = {
  item: Marketplace;
  showTooltip?: boolean;
};

const ItemCard = ({ item, showTooltip }: ItemCardProps) => {
  const date = dateFormat(item.startDate);
  const eventLink = `${BLINKET_EVENT_URL}/${item.sale_url ?? item.id}?utm_source=marketplace`;

  const handleCardEventClick = () => {
    sendEventToGA({
      category: 'Marketplace',
      action: 'click',
      label: 'card-event'
    });
  };

  const CardTitle = () => {
    if (!showTooltip) {
      return (
        <p className={styles.cardTitle} id={`title-${item.id}`} title={item.title}>
          {item.title.length <= 50 ? item.title : item.title.substring(0, 50) + '...'}
        </p>
      );
    }

    return (
      <Tooltip title={item.title}>
        <p className={`${styles.cardTitle} ${styles.wrapText}`} id={`title-${item.id}`}>
          {item.title.length <= 50 ? item.title : item.title.substring(0, 50) + '...'}
        </p>
      </Tooltip>
    );
  };

  return (
    <a
      className={styles.card}
      key={`${item.id}-carousel`}
      onClick={() => handleCardEventClick()}
      href={eventLink}
      target='_blank'
      rel='noreferrer'
    >
      <img
        alt='event image'
        src={item.imageUrl}
        className={styles.cardImage}
        id={`img-${item.id}`}
        onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
          const img = e.currentTarget;
          img.onerror = null;
          img.src = defaultImage;
        }}
      />
      <div className={styles.infoContainer}>
        <p className={styles.cardDate} id={`date-${item.id}`}>
          {date.replace(',', ' às')}
          <br />
        </p>
        <CardTitle />
        {item.type === 'presential' && !!item.place && (
          <p className={`${styles.placeText} ${styles.wrapText}`} id={`local-${item.id}`}>
            {item.place}
          </p>
        )}
        {item.type === 'online' && (
          <p className={styles.placeText} id={`local-${item.id}`}>
            <img src={onlineIcon} style={{ marginRight: '5px' }} />
            {'Evento online'}
          </p>
        )}
      </div>
      {item.type === 'presential' && (
        <p className={styles.typeText} id={`local-${item.id}`}>
          {item.city}
          {', '}
          {item.state}
        </p>
      )}
    </a>
  );
};

export default ItemCard;
